import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNotification } from "@hooks/useNotification";
import ModalIndex from "@Modals/layout/index";
import LexicalEditor from "@components/lexicalEditor";
import { EmployerCourse } from "@services/all.services";
import { $isEmptyTextNode } from "@helpers/_functions";

export default function ModalDescription({
  isOpen,
  selectedPoste,
  toggle,
  readOnly,
  onClickClose
}) {
  const { t: translate } = useTranslation(
    "pages.employés.parcours&Certifications"
  );
  const { showError, showSuccess } = useNotification();
  const notificationHeaderRef = useRef(null);
  const [posteDescription, setPosteDescription] = useState("");
  const [posteDescriptionError, setPosteDescriptionError] = useState(false);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setPosteDescription(selectedPoste?.description || "");
  }, [selectedPoste]);

  const onChangeDescription = (editorState) => {
    setPosteDescription(editorState);
    if (posteDescriptionError) setPosteDescriptionError(false);
  };

  const saveDescription = async () => {
    setLoading(true);
    selectedPoste["description"] = JSON.stringify(posteDescription);
    const isEmptyDescription = $isEmptyTextNode(selectedPoste["description"]);
    if (isEmptyDescription || posteDescription?._nodeMap?.size < 3) {
      setPosteDescriptionError(true);
      if (isEmptyDescription) {
        showError("field_empty");
      } else {
        showError("field_obligatory");
      }
      notificationHeaderRef.current.scrollIntoView({
        block: "end",
        inline: "nearest"
      });
    } else {
      await EmployerCourse.updateById(selectedPoste)
        .then(() => {
          showSuccess("update_action_success", {
            object: "course"
          });
          onClickClose();
        })
        .catch((error) => {
          console.log(error);
        });
    }

    setLoading(false);
  };
  const isEdit = !!(selectedPoste?._id && selectedPoste?.description)
  return (
    <ModalIndex  
      isOpen={isOpen}
      title={translate(
        readOnly
          ? "Description du poste"
          :  "Ajouter/éditer la description du poste"
      )}
      onClickClose={onClickClose}
      isLoading={isLoading}
      buttonOptions={{
        click: saveDescription,
        color: "green",
        title: translate((isEdit) ? "Modifier" : "Créer")
      }}
      buttonCancelOptions={{
        click: () => onClickClose(),
        color: "outlined",
        title: translate("Annuler")
      }}
      widthType="very-large"
      buttonType={readOnly ? "none":"double"}
    >
      <div className="arh-px-0 arh-my-8" ref={notificationHeaderRef}>
        <div className="arh-mb-4">
          <LexicalEditor
            placeholder={translate("Ecrivez votre texte")}
            onChange={onChangeDescription}
            value={posteDescription}
            className="!arh-min-h-[40vh] arh-max-h-[42rem] arh-overflow-y-auto arh-h-full arh-w-full arh-rounded lexical-container arh-boxShadow-lexical_editor"
            hasError={!!posteDescriptionError}
            noIsertToolbar={true}
            isReadonly={readOnly}
          />
        </div>
      </div>
    </ModalIndex  >
  );
}
